import { FC } from "react";

const ProgressBar: FC<{ percentage: string }> = ({ percentage }) => {
    const progressStyle = {
        width: `${percentage}%`,
        backgroundImage: `linear-gradient(to right, #1C6D44 , #26955D, #2FB672)`,
        height: "20px",
        transition: "width 0.5s ease-in-out",
    };

    return (
        <div className="progress-container rounded-full bg-[#D5F0E3]">
            <div
                className="progress-bar rounded-full flex justify-center items-center"
                style={progressStyle}
            >
                <p className="text-xs font-medium text-white">
                    {percentage?.toString()}%
                </p>
            </div>
        </div>
    );
}

export default ProgressBar